export default "October 3, 2018";